var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12314",
    "data-name": "Group 12314",
    transform: "translate(-16 -221)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_868",
    "data-name": "Ellipse 868",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(16 221)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cogwheel",
    d: "M15.347,9.726l0,0-1.019-.936a6.666,6.666,0,0,0,0-1.669l1.022-.939a1.006,1.006,0,0,0,.186-1.229L14.408,3.005a1,1,0,0,0-1.164-.452l-1.323.417a6.06,6.06,0,0,0-1.441-.837L10.175.776A1,1,0,0,0,9.208,0H6.955a1,1,0,0,0-.966.775L5.683,2.134a6.062,6.062,0,0,0-1.441.837L2.918,2.554A1,1,0,0,0,1.758,3L.629,4.954A1,1,0,0,0,.82,6.182l1.019.936a6.785,6.785,0,0,0-.053.834,6.9,6.9,0,0,0,.052.834L.816,9.726a1.006,1.006,0,0,0-.186,1.229L1.756,12.9a1,1,0,0,0,1.164.453l1.323-.417a6.062,6.062,0,0,0,1.441.837l.306,1.357a1,1,0,0,0,.966.777H9.208a1,1,0,0,0,.966-.775l.305-1.358a6.04,6.04,0,0,0,1.441-.837l1.324.417a1,1,0,0,0,1.16-.449l1.129-1.952A1,1,0,0,0,15.347,9.726Zm-7.265,1.54A3.314,3.314,0,1,1,11.4,7.953,3.317,3.317,0,0,1,8.082,11.266Zm0,0",
    transform: "translate(21.418 226.548)",
    fill: "#ed8b00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.9bd51236bd121f81583a8090f5471a63.svg";
export { ForwardRef as ReactComponent };